import { memo } from "react";
import { usePlanStore } from "@/components/plan/store";
import { Dailies } from "./dailies";
import { ProjectList } from "./project-list";
import { Resources } from "./resources";

function PlanKanbanImpl() {
	/** Store */
	const activeDate = usePlanStore((state) => state.activeDate);
	const showResources = usePlanStore((state) => state.showResources);

	/** Render */
	return (
		<div
			className="grow-0 gap-0 grid w-full min-w-0 h-full overflow-x-scroll overflow-y-hidden relative"
			style={{
				gridTemplateColumns: showResources ? "max-content 1fr max-content" : "max-content 1fr",
				gridTemplateRows: "1fr",
				paddingBottom: "0",
			}}
		>
			<ProjectList key={activeDate.dateFormat()} />
			<Dailies />
			{showResources && <Resources />}
		</div>
	);
}

export const PlanKanban = memo(PlanKanbanImpl);
